const pageDecorator: any[] = [
    {
        "id": "notFound",
        "noMenu": true
    },
    {
        "id": "home",
        "role": ["admin", "user"],
        "default": ["admin", "user"],
    },
    {
        "id": "tenants",
        "role": ["superAdmin"]
    },
    {
        "id": "users",
        "role": ["superAdmin"],
        "default": ["superAdmin"],
        "children": [
            { "id": "user" }
        ]
    },
    {
        "id": "vatSettings",
        "role": ["superAdmin"],
        "redirectTo": {
            "all": "vatCountries"
        },
        "children": [
            { "id": "vat" },
            { "id": "vatCountries" }
        ]
    },
    {
        "id": "securityGroups",
        "role": ["superAdmin"]
    },
    {
        "id": "alerts",
        "role": ["admin", "user"],
        "notifications": "create_alert",
    },
    {
        "id": "contractsSection",
        "role": ["admin", "user"],
        "redirectTo": {
            "all": "contracts"
        },
        "children": [

            {
                "id": "contracts",
                "notifications": "update_contract",
                "children": [
                    {
                        "id": "contract"
                    }
                ]

            },
            {
                "id": "contractTypes",
                "role": ["admin"]
            },
            {
                "id": "contractObjects",
                "role": ["admin"]
            },
            {
                "id": "contractTemplates",
                "role": ["admin"]
            },
        ]
    },
    {
        "id": "invoices",
        "role": ["admin"],
        "children": [
            { "id": "invoice" }
        ]
    },
    {
        "id": "drafts",
        "role": ["admin", "user"],
        "children": [
            { "id": "draft" }
        ]
    },
    {
        "id": "businessObjects",
        "role": ["admin", "user"],
        "children": [
            { "id": "businessObject" }
        ]
    },
    {
        "id": "parties",
        "role": ["admin", "user"],
        "children": [
            {
                "id": "party",
                "noMenu": true,
            },
        ]

    },
    {
        "id": "filesAndFolders",
        "notifications": "create_filesAndFolders",
        "role": ["admin", "user"],
        "children": [
            {
                "id": "folderContent",
                "noMenu": true,
            }
        ]
    },
    {
        "id": "quality",
        "role": ["admin", "user"],
        "redirectTo": {
            "all": "qualityControlRules"
        },
        "children": [
            {
                "id": "qualityControlRules",
                "children": [
                    { "id": "qualityControlRule" }
                ]
            }
            ,
            {
                "id": "qualityControlScores",
                "children": [
                    { "id": "qualityControlScore" }
                ]
            }
        ]
    },
    {
        "id": "settings",
        "role": ["admin"],
        "redirectTo": {
            "all": "company"
        },
        "children": [
            {
                "id": "company",
                "showInMenu": true
            },
            {
                "id": "companies",
                "showInMenu": true
            },
            {
                "id": "users",
                "children": [
                    { "id": "user" }
                ]
            },
            {
                "id": "customFields",
                "showInMenu": true,
                "children": [
                    { "id": "gridCustomField" }
                ]
            },
            {
                "id": "sync"
            },
            {
                "id": "recycleBin"
            }
        ]
    },
    {
        "id": "timelines",
        "noMenu": true
    }
,
{
    "id" : "aiPrompts",
    "role": ["superAdmin"],
}
,
{
    "id" : "logs", 
    "role": ["superAdmin", "admin"],
    "children" : [
        {"id" : "log"}
    ]
}
]
export default pageDecorator